export default __webpack_public_path__ + "static/media/fireFN9.96135f6a.svg";